import $ from "jquery";
import "slick-carousel";

$(function () {
	$(".GalleryWithThumbnails-feature").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		// rows: 0,
		arrows: false,
		fade: true,
		asNavFor: ".GalleryWithThumbnails-nav",
	});
	$(".GalleryWithThumbnails-nav").slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		rows: 0,
		infinite: true,
		lazyLoad: "ondemand",
		arrows: true,
		prevArrow:
			'<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>',
		nextArrow:
			'<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
		asNavFor: ".GalleryWithThumbnails-feature",
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
		],
	});
});

